import { api } from 'shared/api';

const passwordApi = api.injectEndpoints({
    endpoints: build => ({
        changePassword: build.mutation<unknown, { oldPassword: string, newPassword: string }>({
            query: ({ oldPassword, newPassword }) => ({
                url: `/user/change-password`,
                method: 'POST',
                body: {oldPassword, newPassword}
            })
        }),
    })
});

export const { useChangePasswordMutation } = passwordApi;

export default passwordApi;
